import { render, staticRenderFns } from "./account-call-dispositions.vue?vue&type=template&id=1f20702a"
import script from "./account-call-dispositions.vue?vue&type=script&lang=js"
export * from "./account-call-dispositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports